import { render, staticRenderFns } from "./evaluation .vue?vue&type=template&id=97708c24&"
import script from "./evaluation .vue?vue&type=script&lang=js&"
export * from "./evaluation .vue?vue&type=script&lang=js&"
import style0 from "./evaluation .vue?vue&type=style&index=0&id=97708c24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports